import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./App.css";


// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripePromise = loadStripe(window.php_vars.stripe_publish_key);

export default function App() {
  const [clientSecret, setClientSecret] = useState("");
  const [amount, setAmount] = useState("");

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    const baseUrl = window.location.origin.includes('localhost') ? `${window.location.origin}/wordpress` : window.location.origin;
    fetch(`${baseUrl}/wp-json/trupayments/v1/stripe/payment_intent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ requestKey: getHeadersParam('requestKey') }),
    })
      .then((res) => {
        res.json().then((data) => {
          setClientSecret(data.clientSecret);
          setAmount(data.amount);
        }).catch((err) => {
          console.log(err);
        });
      });
  }, []);

  const getHeadersParam = (key) => {
    let params = (new URL(document.location)).searchParams;
    return params.get(key);

  };

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm amount={amount} />
        </Elements>
      )}
    </>
  );
}